import { cloneDeepSafe } from '../utils/clone-object.util';

export function declareDto<Type>(obj: Type): Type {
    return Object.freeze(cloneDeepSafe(obj)) as Type;
}
